import { VITE_BASE_URL } from '@src/main/env';
import axios, { AxiosError } from 'axios';

export type TokenProvider = {
  getToken: () => Promise<string>;
};

interface Api {
  get: <T>(endpoint: string, token: string, params?: unknown) => Promise<T>;
  put: <T>(endpoint: string, token: string, body: unknown) => Promise<T>;
  post: <T>(endpoint: string, token: string, body: unknown) => Promise<T>;
  delete: <T>(endpoint: string, token: string) => Promise<T>;
}

const api: Api = {
  get: (endpoint: string, token: string, params: unknown = {}) =>
    axios
      .get(`${VITE_BASE_URL}/api${endpoint}`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(err),
  put: (endpoint: string, token: string, body: unknown) =>
    axios
      .put(`${VITE_BASE_URL}/api${endpoint}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(err),
  post: (endpoint: string, token: string, body: unknown) =>
    axios
      .post(`${VITE_BASE_URL}/api${endpoint}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(err),
  delete: (endpoint: string, token: string) =>
    axios
      .delete(`${VITE_BASE_URL}/api${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(err),
};

const err = (error: AxiosError) => {
  if (error.response?.status === 401) {
    window.location.href = '/login';
  } else {
    throw error;
  }
};
export { api };
